import { Navigate } from 'react-router';
import { UserContext } from '~/app';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import { useFeatureFlag, useFeatureFlagStatus } from '~/features/feature-flags/useFeatureFlag';
import { EmployerCalendarPage } from '~/features/market/calendar/EmployerCalendarPage';
import { ProviderAvailabilityPage } from '~/features/provider-hlx/calendar/ProviderAvailabilityPage';
import { paths } from './routes';

export const HlxCalendarRoute = () => {
  const isProvider = UserContext.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );
  const providerCalendarEnabled = useFeatureFlag('providerCalendar');
  const flagStatus = useFeatureFlagStatus();

  if (!isProvider) return <EmployerCalendarPage />;
  if (flagStatus === 'idle' || flagStatus === 'loading') return <LoadingSpinner />;
  if (!providerCalendarEnabled) return <Navigate replace to={paths.hlx.jobOpportunities} />;
  return <ProviderAvailabilityPage />;
};
